import Sqids from "sqids";

export default function useSqids() {

    return new Sqids({
        minLength: 8,
    })

}